module.exports = "<h1 class=\"gw-titles-title\" ng-class=\"{ 'gw-titles-title_offset': hasOffset }\">\n    <ng-transclude></ng-transclude>\n</h1>"